// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "actioncable" + "-" + "78c5ae7ad4bf23d0336f" + ".chunk.js";
};